"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkUniqueCode = checkUniqueCode;
exports.checkUniqueName = checkUniqueName;
exports.create = create;
exports["default"] = void 0;
exports.deleteParentAccount = deleteParentAccount;
exports.fetchParentMetric = fetchParentMetric;
exports.get = get;
exports.getClients = getClients;
exports.getInvoicingEntities = getInvoicingEntities;
exports.getRecordsSuggestions = getRecordsSuggestions;
exports.typeaheadSearch = typeaheadSearch;
exports.update = update;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var base = '/api/parent-account';

function get(parentAccountId) {
  return _api["default"].get("".concat(base, "/").concat(parentAccountId, "&bare")).then(_api.extractData)["catch"](_api.errorHandler);
}

function create(parentAccountFormData) {
  var parentAccountData = parentAccountFormData;
  return _api["default"].post(base, parentAccountData).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(oldParentAccountData, parentAccountFormData) {
  var parentAccountData = parentAccountFormData;
  return _api["default"].put(base + '/' + oldParentAccountData.id, parentAccountData).then(_api.extractData)["catch"](_api.errorHandler);
}
/**
 * Gets client users for the passed parent account ID
 *
 * @param {Number} parentAccountId
 * @param {object} options
 * @param { number|null } options.limit enable overriding the limit with a number or null (to remove the limit)
 */


function getClients(parentAccountId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var limit = 20;

  if (options.limit !== undefined) {
    limit = options.limit;
  }

  var url = limit ? "".concat(base, "/").concat(parentAccountId, "/clients?limit=").concat(limit) : "".concat(base, "/").concat(parentAccountId, "/clients");
  return _api["default"].get(url).then(_api.extractData)["catch"](_api.errorHandler);
}

function checkUniqueName(parentAccountName, parentAccountId) {
  var url = base + "/check-unique-name?value=".concat(parentAccountName);

  if (parentAccountId) {
    url = "".concat(url, "&id=").concat(parentAccountId);
  }

  return _api["default"].get(url).then(_api.extractData)["catch"](_api.errorHandler);
}

function checkUniqueCode(parentAccountCode) {
  return _api["default"].get(base + "/check-unique-code?value=".concat(parentAccountCode)).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteParentAccount(parentAccountId) {
  return _api["default"]["delete"]("".concat(base, "/").concat(parentAccountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getInvoicingEntities(parentAccountId, accountId) {
  var query = accountId ? "?accountId=".concat(accountId) : '';
  return _api["default"].get("/api/invoicing-entity/parent-account/".concat(parentAccountId).concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeaheadSearch(query) {
  return _api["default"].get("".concat(base, "/typeahead-search?q=").concat(encodeURIComponent(query))).then(_api.extractData)["catch"](_api.errorHandler);
}

function getRecordsSuggestions(query, recordTypes) {
  var queryParams = _queryString["default"].stringify({
    q: query,
    recordType: recordTypes
  });

  return _api["default"].get("".concat(base, "/autocomplete-records?").concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function fetchParentMetric(_ref) {
  var id = _ref.id,
      month = _ref.month,
      type = _ref.type;

  if (!['office', 'account'].includes(type)) {
    throw new Error('type needs to be eather office or account');
  }

  var monthStr = month ? "?month=".concat(month) : '';
  return _api["default"].get("/api/report/".concat(type, "-metric/").concat(id).concat(monthStr)).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  get: get,
  create: create,
  update: update,
  getClients: getClients,
  checkUniqueName: checkUniqueName,
  checkUniqueCode: checkUniqueCode,
  deleteParentAccount: deleteParentAccount,
  getInvoicingEntities: getInvoicingEntities,
  typeaheadSearch: typeaheadSearch,
  getRecordsSuggestions: getRecordsSuggestions,
  fetchParentMetric: fetchParentMetric
};
var _default = api;
exports["default"] = _default;